import { Node_Type } from "./../../ricos-types";
import Caption from "../../_shared/figure/viewer-caption";
import Video from "./viewer-video";
const nodeViewRenderers = {
  [Node_Type.VIDEO]: Video,
  [Node_Type.CAPTION]: Caption
};
export {
  nodeViewRenderers
};
//# sourceMappingURL=nodeViewRenderers.js.map
